<template>
    <ul class="study-details">
        <li>
            <i class="icon icon-university"></i>
            <span
                class="leading-6"
                v-text="institutionName"
            ></span>
        </li>
        <li>
            <i class="icon icon-course"></i>
            <span
                v-if="isUserPupil"
                class="leading-6"
                v-text="study.university.name"
            ></span>
            <span
                v-else
                class="leading-6"
            >
                <span
                    v-if="study.university.has_specific_programs && study.university.study_programs[0].type"
                    v-text="`${study.university.study_programs[0].name} - ${study.university.study_programs[0].type}`"
                ></span>
                <span
                    v-else
                    v-text="`${study.university.study_programs[0].name}`"
                ></span>
                <Badge
                    v-if="study.university.study_programs.length > 1"
                    v-tooltip="formattedExtraMajor"
                    appearance="default"
                    class="cursor-pointer hover:opacity-75 ml-4 lg:ml-0"
                >
                    {{
                        t('show.studies.more_majors', {
                            count: study.university.study_programs.length - 1,
                        })
                    }}
                </Badge>
            </span>
        </li>
        <li>
            <i class="icon icon-check-in"></i>
            <span
                class="leading-6"
                v-text="educationInfo"
            ></span>
        </li>
    </ul>
</template>

<script>
import { defineComponent } from 'vue';
import Badge from '@components/Badge';
import { displayStudySemester } from '@/utils/semesterUtils';
import { useTranslation } from 'i18next-vue';

export default defineComponent({
    name: 'ProfileShowStudy',
    components: {
        Badge,
    },
    props: {
        /**
         * User primary study object that contains institution and education info
         */
        study: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const { t } = useTranslation('profile');
        return { t };
    },
    computed: {
        institutionName() {
            return !this.isUserPupil ? this.study.university.name : this.study.schools[0]?.name;
        },
        isUserPupil() {
            return this.study.university.institution_type === 0;
        },
        educationInfo() {
            return !this.isUserPupil
                ? this.semesterDisplayName(this.study.semester)
                : this.study.university.study_programs[0].type;
        },
        formattedExtraMajor() {
            if (
                !this.study ||
                !this.study.university.study_programs ||
                this.study.university.study_programs.length < 2
            ) {
                return '';
            }
            return this.study.university.has_specific_programs && this.study.university.study_programs[1].type
                ? `${this.study.university.study_programs[1].name} - ${this.study.university.study_programs[1].type}`
                : this.study.university.study_programs[1].name;
        },
    },
    methods: {
        semesterDisplayName(semester) {
            return displayStudySemester(semester);
        },
    },
});
</script>

<style lang="scss" scoped>
.study-details {
    li {
        @apply text-left text-black text-base items-center mb-7 flex;

        &:last-child {
            @apply mb-0;
        }

        .icon {
            @apply mr-4 min-w-6 w-6 h-6;
            @screen md {
                @apply min-w-8 mr-6 w-8 h-8;
            }
        }
    }
}
@screen lg {
    .study-details {
        @apply flex;

        li {
            @apply flex-1 flex-col text-center mb-0;

            .icon {
                @apply mb-4 mr-0;
            }
        }
    }
}
</style>
